import {inject, Injectable, QueryList} from '@angular/core';
import {GetSelectDataParams, RecordTableColumnParams, SelectData} from "../../../../../../types/records-table.types";
import {RecordTableApiService} from "../../../../../../services-api/record-table-api.service";
import {MatOption} from "@angular/material/select";

@Injectable({
  providedIn: 'root'
})
export class SelectRecordTableItemService {
  private recordTableApiService: RecordTableApiService = inject(RecordTableApiService);

  public getSelectData(columnParam: RecordTableColumnParams, recordId: number): Promise<Array<SelectData>> {
    const getSelectDataParams: GetSelectDataParams = {
      propertyLazySelect: columnParam.columnProperties.LAZY_SELECT!,
      id: recordId
    };

    return new Promise((resolve, reject) => {
      this.recordTableApiService.fetchSelectData(getSelectDataParams).subscribe({
        next: (selectData: Array<SelectData>) => resolve(selectData),
        error: (error) => reject(error)
      });
    });
  }

  public initializeSelectOptions(columnParam: RecordTableColumnParams): Array<SelectData> {
    return columnParam.metaSelectKeyList?.length ? [ ...columnParam.metaSelectKeyList ] : [];
  }

  public scrollSelectedOptionIntoView(index: number, matOptions: QueryList<MatOption>): void {
    if (matOptions?.length <= index) { return; }

    const option = matOptions.get(index);
    option?._getHostElement().scrollIntoView({
      behavior: 'smooth',
      block: 'nearest'
    });
  }

  public isMultiSelect(columnParam: RecordTableColumnParams): boolean {
    return columnParam.type === 'MULTI_SELECT' ||
      columnParam.type === 'ENUM_MULTI_SELECT' ||
      columnParam.filterType === 'MULTIPLE_SELECT';
  }
}
